const eventPath = (eventName?: string, uuid?: string) => {
  if (eventName) return eventName;
  else return `event/${uuid}`;
};

export default eventPath;
